import { render, staticRenderFns } from "./SaveTemplate.vue?vue&type=template&id=6e5c79ed&scoped=true"
import script from "./SaveTemplate.vue?vue&type=script&lang=js"
export * from "./SaveTemplate.vue?vue&type=script&lang=js"
import style0 from "./SaveTemplate.vue?vue&type=style&index=0&id=6e5c79ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c79ed",
  null
  
)

export default component.exports